var TSingleSPSlipMode = (function () {
    "use strict";
    var api = <any> {};

    // Overrides SingleSPSlipMode
    api.updateView = function () {
        TUniSlip.buildView();
    };

    // Template logic splitter
    api.buildOptions = function (selections) {
        return TSingleOptions.buildSingle(this, selections);
    };

    // Adapter for Array.push template implementation
    api.buildSelectionInnerView = function (selection, selectionUpdated) {
        return TBuildLine.buildInnerView(selection, this, { buildInner: true, updated: selectionUpdated, isSP: true });
    };

    api.buildHeader = function () {
        return "";
    };

    return api;
}());

window.TSingleSPSlipMode = TSingleSPSlipMode;